import { Link } from "react-router-dom";

function SidebarHeader() {
  return (
    <>
      <Link
        to="/"
        className="d-flex align-items-center mb-md-0 me-md-auto text-decoration-none"
      >
        <img
          src={import.meta.env.VITE_PUBLIC_URL + "/favicon.png"}
          alt="Lumenko logo"
        />
        <span className="fs-3">Lumen@home</span>
      </Link>
    </>
  );
}

export default SidebarHeader;
